import { Language } from '../../types/language'

export type OfferingsCopy = {
  heading: string
  eyebrow: string
  oneOnOne: {
    title: string
    tagline: string
    description: string
    cta: string
  }
  group: {
    title: string
    tagline: string
    description: string
    cta: string
  }
  waitlist: {
    title: string
    note: string
    nameLabel: string
    namePlaceholder: string
    emailLabel: string
    emailPlaceholder: string
    submit: string
    close: string
    success: string
  }
}

export const offeringsCopy: Record<Language, OfferingsCopy> = {
  nl: {
    heading: 'Jouw reis gaat verder',
    eyebrow: 'Kies jouw pad',
    oneOnOne: {
      title: '1-op-1 coaching',
      tagline: 'Kies met vertrouwen.',
      description:
        'Een persoonlijk traject van zes gesprekken waarin je ontdekt wat jij belangrijk vindt en weer leert vertrouwen op je intuïtie. Je gaat weg met helderheid én het zelfvertrouwen om keuzes te maken die echt van jou zijn. Online of wandelend rond Utrecht.',
      cta: 'Bekijk het traject',
    },
    group: {
      title: 'Retreats',
      tagline: 'Een weekend dat blijft.',
      description:
        'Een weekend in de natuur met een kleine groep mensen die met dezelfde vragen rondlopen. Door coaching, stilte en echte gesprekken ontstaan inzichten waar je jaren op kunt terugvallen, en verbindingen die veel verder reiken dan dat ene weekend. En na zondag stopt het niet: als groep volg je samen op wat je hebt ontdekt.',
      cta: 'Zet me op de wachtlijst',
    },
    waitlist: {
      title: 'Wachtlijst retreats',
      note: 'Je hoort als eerste wanneer de data bekend zijn.',
      nameLabel: 'Naam',
      namePlaceholder: 'Je naam',
      emailLabel: 'E-mailadres',
      emailPlaceholder: 'jij@voorbeeld.nl',
      submit: 'Zet me op de wachtlijst',
      close: 'Sluiten',
      success: 'Gelukt. Je staat op de wachtlijst en hoort als eerste van me.',
    },
  },
  en: {
    heading: 'Your journey continues',
    eyebrow: 'Choose your path',
    oneOnOne: {
      title: '1-on-1 coaching',
      tagline: 'Choose with confidence.',
      description:
        'A personal journey of six conversations in which you discover what matters to you and learn to trust your intuition again. You leave with clarity and the confidence to make choices that are truly your own. Online or walking around Utrecht.',
      cta: 'See the journey',
    },
    group: {
      title: 'Retreats',
      tagline: 'A weekend that stays with you.',
      description:
        'A weekend in nature with a small group of people carrying the same questions. Through coaching, silence, and real conversations, insights emerge that you can draw on for years, along with connections that reach far beyond that one weekend. And it does not end on Sunday: as a group you follow up together on what you discovered.',
      cta: 'Add me to the waitlist',
    },
    waitlist: {
      title: 'Retreat waitlist',
      note: 'You will be the first to hear when the dates are announced.',
      nameLabel: 'Name',
      namePlaceholder: 'Your name',
      emailLabel: 'Email address',
      emailPlaceholder: 'you@example.com',
      submit: 'Add me to the waitlist',
      close: 'Close',
      success: "You're on the waitlist. I'll be in touch first.",
    },
  },
}
